import { ApiResourceMethod } from '@/api/api-requests-factory';
import { TagListRequestParams, TagListItemResponseModel } from '@/models/dictionary/tag-list.model';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';

export default class GetTagListRequest extends ApiResourceMethod<TagListItemResponseModel[]> {
  public perform(filterList: TagListRequestParams): Promise<TagListItemResponseModel[]> {
    return this.performer.requestWithMapper(
      { params: { ...filterList } },
      (payload: BaseResponse<TagListItemResponseModel[]>) => {
        return payload.data;
      },
    );
  }
}
